

const factList = [
    {
        fact: "I have two pets, Cappu (dog) and Ccino (cat), whom I love very much",
        icon: "paw"
    },
    {
        fact: "Top 3 anime: Mob Psycho 100, Jujutsu Kaisen, Bakuman - don't @ me",
        icon: "video"
    },
    {
        fact: "My favorite book series is The Stormlight Archive (fantasy / fiction recommendations are always welcome)",
        icon: "book"
    },
    {
        fact: "BIG COFFEE GUY, favorite is naturally processed coffees from Ethiopia, brewed as either pour over or a flat white with a splash of simple syrup",
        icon: "coffee"
    },
    {
        fact: "A wise man once told me, 'I work out so that I can hold every dog like it's a puppy'",
        icon : "dumbbell"
    },
    {
        fact: "MMOs & RPGs are my jam and my favorite game is Zelda: BoTW (Pokemon has a special place in my heart though)",
        icon: "gamepad"
    },
    {
        fact: "Dice rolling enthusiast and owner of at least one wizard hat (Critical Role S3 anyone?)",
        icon: "dice-d20"
    }
];


export default factList;